// traducir — función pura detrás de t(). Sin React, para poder probarla.
//
// Orden de búsqueda: idioma pedido → español → la clave misma. Nunca devuelve
// vacío: un texto faltante se ve como la clave y salta a la vista.
import { getIdioma, IDIOMAS, type Clave } from './idiomas.ts';

export type VarsTraduccion = Record<string, string | number>;

export function interpolar(texto: string, vars?: VarsTraduccion): string {
  if (!vars) return texto;
  return texto.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
}

export function traducir(idioma: string | null | undefined, clave: Clave, vars?: VarsTraduccion): string {
  const texto = getIdioma(idioma).diccionario[clave] ?? IDIOMAS[0].diccionario[clave] ?? clave;
  return interpolar(texto, vars);
}
